import { useQuery, UseQueryOptions } from "react-query";
import {
  getInfrastructureDeployedsRequest,
  getPopularTagRequest,
  getSupportedChainRequest,
  masterAchievementRequest,
  masterAddActionRequest,
  masterCategoryRequest,
  masterChildTagRequest,
  masterCompanyRequireRequest,
  masterGeoRestrictionsRequest,
  masterJudgingRequest,
  masterLengthRequest,
  masterLocationRequest,
  masterOccupationElbRequest,
  masterOccupationParRequest,
  masterOccupationRelateElbRequest,
  masterOccupationRelateParRequest,
  masterOrganizationRequest,
  masterParticipantAgeRequest,
  masterPrizeCurrencyRequest,
  masterSpecialtyRequest,
  masterStatusRequest,
  masterTagRequest,
  masterTeamRequireRequest,
  masterTechnologyRequest,
  masterThemeRequest,
  masterTypeRequest,
} from "./request";
import {
  IMasterAchievementResponse,
  IMasterJudgingMasterResponse,
  IMasterOccupationRelateElbResponse,
  IMasterOccupationRelateParResponse,
  IMaster,
  IMasterTagResponse,
  IMasterThemeResponse,
  IMasterTag,
  ISupportedChain,
  IInfrastructureDeployeds,
} from "./types";

export const useMasterAchievement = (
  option?: UseQueryOptions<IMasterAchievementResponse[], Error>
) => {
  return useQuery<IMasterAchievementResponse[], Error>(
    "masterAchievements",
    masterAchievementRequest,
    option
  );
};

export const useMasterAddAction = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterAddActions",
    masterAddActionRequest,
    option
  );
};

export const useMasterComunity = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "mastercommunity",
    masterAddActionRequest,
    option
  );
};

export const useMasterCompanyRequire = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterCompanyRequire",
    masterCompanyRequireRequest,
    option
  );
};

export const useMasterGeoRestrictions = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterGeoRestrictions",
    masterGeoRestrictionsRequest,
    option
  );
};

export const useMasterJudging = (
  option?: UseQueryOptions<IMasterJudgingMasterResponse[], Error>
) => {
  return useQuery<IMasterJudgingMasterResponse[], Error>(
    "masterJudging",
    masterJudgingRequest,
    option
  );
};

export const useMasterLength = (option?: UseQueryOptions<string[], Error>) => {
  return useQuery<string[], Error>("masterLength", masterLengthRequest, option);
};

export const useMasterLocation = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterLocation",
    masterLocationRequest,
    option
  );
};

export const useMasterOccupationElb = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterOccupationElb",
    masterOccupationElbRequest,
    option
  );
};

export const useMasterOccupationPar = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterOccupationPar",
    masterOccupationParRequest,
    option
  );
};

export const useMasterOccupationRelateElb = (
  option?: UseQueryOptions<IMasterOccupationRelateElbResponse, Error>
) => {
  return useQuery<IMasterOccupationRelateElbResponse, Error>(
    "masterOccupationRelateElb",
    masterOccupationRelateElbRequest,
    option
  );
};

export const useMasterOccupationRelatePar = (
  option?: UseQueryOptions<IMasterOccupationRelateParResponse, Error>
) => {
  return useQuery<IMasterOccupationRelateParResponse, Error>(
    "masterOccupationRelatePar",
    masterOccupationRelateParRequest,
    option
  );
};

export const useMasterOrganization = (
  option?: UseQueryOptions<IMaster[], Error>
) => {
  return useQuery<IMaster[], Error>(
    "masterOrganization",
    masterOrganizationRequest,
    option
  );
};

export const useMasterParticipantAge = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterParticipantAge",
    masterParticipantAgeRequest,
    option
  );
};

export const useMasterPrizeCurrency = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterPrizeCurrency",
    masterPrizeCurrencyRequest,
    option
  );
};

export const useMasterSpecialty = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterSpecialty",
    masterSpecialtyRequest,
    option
  );
};

export const useMasterStatus = (option?: UseQueryOptions<string[], Error>) => {
  return useQuery<string[], Error>("masterStatus", masterStatusRequest, option);
};

export const useMasterTag = (
  option?: UseQueryOptions<IMasterTagResponse[], Error>
) => {
  return useQuery<IMasterTagResponse[], Error>(
    "masterTag",
    masterTagRequest,
    option
  );
};

export const useMasterTeamRequire = (
  option?: UseQueryOptions<string[], Error>
) => {
  return useQuery<string[], Error>(
    "masterTeamRequire",
    masterTeamRequireRequest,
    option
  );
};

export const useMasterTheme = (
  option?: UseQueryOptions<IMasterThemeResponse[], Error>
) => {
  return useQuery<IMasterThemeResponse[], Error>(
    "masterTheme",
    masterThemeRequest,
    option
  );
};

export const usePopularTag = (
  option?: UseQueryOptions<IMasterThemeResponse[], Error>
) => {
  return useQuery<IMasterThemeResponse[], Error>(
    "popularTage",
    getPopularTagRequest,
    option
  );
};

export const useMasterType = (option?: UseQueryOptions<string[], Error>) => {
  return useQuery<string[], Error>("masterType", masterTypeRequest, option);
};

export const useMasterTechnology = (
  option?: UseQueryOptions<IMaster[], Error>
) => {
  return useQuery<IMaster[], Error>(
    "masterTechnology",
    masterTechnologyRequest,
    option
  );
};

export const useMasterCategory = (
  option?: UseQueryOptions<IMaster[], Error>
) => {
  return useQuery<IMaster[], Error>(
    "masterCategory",
    masterCategoryRequest,
    option
  );
};

export const useMasterChildTag = (
  option?: UseQueryOptions<IMasterTag, Error>
) => {
  return useQuery<IMasterTag, Error>(
    "masterChildTag",
    masterChildTagRequest,
    option
  );
};
export const useSupportedChain = (
  option?: UseQueryOptions<ISupportedChain[], Error>
) => {
  return useQuery<ISupportedChain[], Error>(
    "SupportedChains",
    getSupportedChainRequest,
    option
  );
};

export const useInfrastructureDeployeds = (
  option?: UseQueryOptions<IInfrastructureDeployeds[], Error>
) => {
  return useQuery<IInfrastructureDeployeds[], Error>(
    "masterInfrastructureDeployeds",
    getInfrastructureDeployedsRequest,
    option
  );
};
